// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_CLEAR_VERSIONS,
} from './constants';

export function clearVersions() {
  return {
    type: SIMULADOR_FINANCIERO_CLEAR_VERSIONS,
  };
}

export function reducer(state, action) {
  if (action.type === SIMULADOR_FINANCIERO_CLEAR_VERSIONS) {
      return {
        ...state,
        versiones: []
      };
  }
  else {
      return state;
  }
}
